package tools.goodtime.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initLegalPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("legal.md", FrontMatterElement.Builder { addScalar("title", "Goodtime Terms & Privacy Policy"); }))
}

@Page("/legal")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun LegalPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("goodtime-terms-privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("Goodtime Terms & Privacy Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Last Updated:")
        }
        org.jetbrains.compose.web.dom.Text(" January 10, 2026")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Privacy First:")
        }
        org.jetbrains.compose.web.dom.Text(" Goodtime does not collect, store, or sell your personal data. All your information stays on your device, or optionally in your own Google Drive or iCloud storage that only you control.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#terms-of-service") {
                org.jetbrains.compose.web.dom.Text("Terms of Service")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#privacy-policy") {
                org.jetbrains.compose.web.dom.Text("Privacy Policy")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("#contact") {
                org.jetbrains.compose.web.dom.Text("Contact")
            }
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("terms-of-service") }) {
        org.jetbrains.compose.web.dom.Text("Terms of Service")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("1-acceptance-of-terms") }) {
        org.jetbrains.compose.web.dom.Text("1. Acceptance of Terms")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("By using the Goodtime app, you agree to these Terms of Service.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("2-description-of-service") }) {
        org.jetbrains.compose.web.dom.Text("2. Description of Service")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goodtime is a productivity timer app available for Android and iOS. It is open source software (GPL-3.0 license) available at ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/adrcotfas/goodtime") {
            org.jetbrains.compose.web.dom.Text("github.com/adrcotfas/goodtime")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("3-in-app-purchases") }) {
        org.jetbrains.compose.web.dom.Text("3. In-App Purchases")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The app offers optional one-time purchases processed through Google Play, App Store, and RevenueCat. Refund requests follow platform policies, but contact us at ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:contact@goodtime.tools") {
            org.jetbrains.compose.web.dom.Text("contact@goodtime.tools")
        }
        org.jetbrains.compose.web.dom.Text(" for case-by-case consideration.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("4-cloud-sync-optional") }) {
        org.jetbrains.compose.web.dom.Text("4. Cloud Sync (Optional)")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can optionally sync data via Google Drive (Android) or iCloud (iOS). You are responsible for your cloud storage account and data backups. We do not guarantee continuous availability or prevention of data loss.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("5-disclaimers") }) {
        org.jetbrains.compose.web.dom.Text("5. Disclaimers")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("THE APP IS PROVIDED \"AS IS\" WITHOUT WARRANTIES OF ANY KIND. We make no guarantees regarding productivity outcomes or that the app will be error-free.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("6-limitation-of-liability") }) {
        org.jetbrains.compose.web.dom.Text("6. Limitation of Liability")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE APP.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("7-third-party-services") }) {
        org.jetbrains.compose.web.dom.Text("7. Third-Party Services")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The app integrates with Google Play Services, Google Drive, iCloud, and RevenueCat. Your use is subject to their respective terms and privacy policies.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("8-changes-to-terms") }) {
        org.jetbrains.compose.web.dom.Text("8. Changes to Terms")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may update these terms from time to time. Changes will be posted here with an updated date.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("9-governing-law") }) {
        org.jetbrains.compose.web.dom.Text("9. Governing Law")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("These terms are governed by the laws of the European Union.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("Privacy Policy")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("we-do-not-collect-your-data") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("We Do Not Collect Your Data")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Goodtime does not collect, store, or sell any of your personal data.")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("No analytics or tracking")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("No advertisements")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("No user accounts required")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("No email addresses or personal information collected")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("your-data-stays-with-you") }) {
        org.jetbrains.compose.web.dom.Text("Your Data Stays With You")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("All your data remains on your device. If you enable optional cloud sync:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Android:")
            }
            org.jetbrains.compose.web.dom.Text(" Data is stored in YOUR Google Drive (we cannot access it)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("iOS:")
            }
            org.jetbrains.compose.web.dom.Text(" Data is stored in YOUR iCloud (we cannot access it)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Your control:")
            }
            org.jetbrains.compose.web.dom.Text(" You can delete this data anytime through your Google Drive or iCloud settings")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("in-app-purchases") }) {
        org.jetbrains.compose.web.dom.Text("In-App Purchases")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Purchases are processed by Google Play, App Store, and RevenueCat. ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("We do not collect or store payment information.")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("third-party-services") }) {
        org.jetbrains.compose.web.dom.Text("Third-Party Services")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Google Play/App Store:")
            }
            org.jetbrains.compose.web.dom.Text(" May collect information per their privacy policies")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("F-Droid:")
            }
            org.jetbrains.compose.web.dom.Text(" No Google Play Services if obtained from F-Droid")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Website:")
            }
            org.jetbrains.compose.web.dom.Text(" ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://goodtime.tools") {
                org.jetbrains.compose.web.dom.Text("goodtime.tools")
            }
            org.jetbrains.compose.web.dom.Text(" is a static site with no cookies, analytics, or tracking")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("data-retention") }) {
        org.jetbrains.compose.web.dom.Text("Data Retention")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Local data:")
            }
            org.jetbrains.compose.web.dom.Text(" On your device until you uninstall")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Synced data:")
            }
            org.jetbrains.compose.web.dom.Text(" In your Google Drive/iCloud until you delete it")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Purchase records:")
            }
            org.jetbrains.compose.web.dom.Text(" Retained by Google Play, App Store, and RevenueCat per their policies")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("your-rights-gdpr") }) {
        org.jetbrains.compose.web.dom.Text("Your Rights (GDPR)")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you are in the EU, you have rights to access, delete, and object to data processing. Since we don't collect your personal data, these rights primarily relate to data in your own Google Drive or iCloud accounts, which you can manage directly.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Data portability:")
        }
        org.jetbrains.compose.web.dom.Text(" Your data is already in your control on your device and optionally in your Google Drive/iCloud. You can access and manage it directly from those locations.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("open-source") }) {
        org.jetbrains.compose.web.dom.Text("Open Source")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goodtime is open source. Verify our privacy claims by reviewing the code at ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/adrcotfas/goodtime") {
            org.jetbrains.compose.web.dom.Text("github.com/adrcotfas/goodtime")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("changes-to-this-policy") }) {
        org.jetbrains.compose.web.dom.Text("Changes to This Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may update this policy from time to time. Changes will be posted here with an updated date.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("contact") }) {
        org.jetbrains.compose.web.dom.Text("Contact")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Questions? Contact us at ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:contact@goodtime.tools") {
            org.jetbrains.compose.web.dom.Text("contact@goodtime.tools")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
}
